/**
 * Maps an account/subscription/GHL status string to a flowbite Badge color.
 * Shared by CustomerDetail and the member Security tab. (CustomerInformation.tsx
 * still has its own local copy whose `trialing` maps to gray, not info; left
 * as-is to avoid changing that screen's badge behavior.)
 */
export const getStatusColor = (
  status?: string
): "success" | "failure" | "warning" | "info" | "gray" => {
  switch ((status ?? "").toLowerCase()) {
    case "active":
      return "success";
    case "inactive":
      return "failure";
    case "pending":
      return "warning";
    case "trialing":
      return "info";
    default:
      return "gray";
  }
};
